<template>
  <div class="box-konten">
    <div class="box-code">
        <input type="text" ref="input0" v-model="input0" class="input is-medium" maxlength="1">
        <input type="text" ref="input1" v-model="input1" class="input is-medium" maxlength="1">
        <input type="text" ref="input2" v-model="input2" class="input is-medium" maxlength="1">
        <input type="text" ref="input3" v-model="input3" class="input is-medium" maxlength="1">
        <input type="text" ref="input4" v-model="input4" class="input is-medium" maxlength="1">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'is-large'
    },
    value: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function,
      default: () => {}
    }
  },

  watch: {
    input0(val) {
     this.onChange(`${val}${this.input1}${this.input2}${this.input3}${this.input4}`);
     if (!this.isEmpty(val)) {
      this.$refs.input1.focus();
      this.$refs.input1.select();
     }
    },
    input1(val) {
     this.onChange(`${this.input0}${val}${this.input2}${this.input3}${this.input4}`);
     if (!this.isEmpty(val)) {
      this.$refs.input2.focus();
      this.$refs.input2.select();
     } else {
      this.$refs.input0.focus();
      this.$refs.input0.select();
     }
    },
    input2(val) {
     this.onChange(`${this.input0}${this.input1}${val}${this.input3}${this.input4}`);
     if (!this.isEmpty(val)) {
      this.$refs.input3.focus();
      this.$refs.input3.select();
     } else {
      this.$refs.input1.focus();
      this.$refs.input1.select();
     }
    },
    input3(val) {
     this.onChange(`${this.input0}${this.input1}${this.input2}${val}${this.input4}`);
     if (!this.isEmpty(val)) {
      this.$refs.input4.focus();
      this.$refs.input4.select();
     } else {
      this.$refs.input2.focus();
      this.$refs.input2.select();
     }
    },
    input4(val) {
     this.onChange(`${this.input0}${this.input1}${this.input2}${this.input3}${val}`);
     if (this.isEmpty(val)) {
      this.$refs.input3.focus();
      this.$refs.input3.select();
     }
    },
  },

  data() {
    return {
      input0: this.value.charAt(0),
      input1: this.value.charAt(1),
      input2: this.value.charAt(2),
      input3: this.value.charAt(3),
      input4: this.value.charAt(4),
    }
  }
}
</script>

<style scoped>
  .input {
    font-weight: bold;
  }
</style>
